import { Field, Label, mergeClasses, useId } from '@fluentui/react-components';
import { IBaseDatePickerProps } from '../BaseInputField/BaseInputField.types';
import { useBaseInputFieldStyles } from '../BaseInputField/BaseInputField.styles';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { useMemo } from 'react';

const BaseDatePicker = (props: IBaseDatePickerProps) => {
    const { value, className, label, required, onChange, name } = props;
    const styles = useBaseInputFieldStyles();

    const inputId = `input-${name}`;
    const uniqueId = useId(`input-${name}`);

    const dateValue = useMemo(() => (value ? new Date(value ?? '') : null), [value]);

    const handleChange = (newValue: Date | null | undefined) =>
        onChange(newValue ? newValue.toLocaleDateString() : '');

    return (
        <div className={className ? mergeClasses(styles.root, className) : styles.root}>
            <div>
                <Label htmlFor={inputId} className={styles.label}>
                    {label}
                </Label>
                {required && <span className={styles.requiredAsterisk}>*</span>}
            </div>
            <Field>
                <DatePicker
                    value={dateValue}
                    allowTextInput
                    id={uniqueId}
                    className={styles.inputField}
                    data-testid={inputId}
                    onSelectDate={handleChange}
                    inlinePopup
                />
            </Field>
        </div>
    );
};

export default BaseDatePicker;
